/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_city = /** @type {(inputs: {}) => string} */ () => {
	return `Město`
};

const da_city = /** @type {(inputs: {}) => string} */ () => {
	return `By`
};

const de_city = /** @type {(inputs: {}) => string} */ () => {
	return `Stadt`
};

const en_city = /** @type {(inputs: {}) => string} */ () => {
	return `City`
};

const es_city = /** @type {(inputs: {}) => string} */ () => {
	return `Ciudad`
};

const fr_city = /** @type {(inputs: {}) => string} */ () => {
	return `Ville`
};

const hu_city = /** @type {(inputs: {}) => string} */ () => {
	return `Város`
};

const it_city = /** @type {(inputs: {}) => string} */ () => {
	return `Città`
};

const nl_city = /** @type {(inputs: {}) => string} */ () => {
	return `Stad`
};

const pl_city = /** @type {(inputs: {}) => string} */ () => {
	return `Miasto`
};

const pt_city = /** @type {(inputs: {}) => string} */ () => {
	return `Cidade`
};

const sv_city = /** @type {(inputs: {}) => string} */ () => {
	return `Stad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const city = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.city(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("city", locale)
	if (locale === "cs") return cs_city(inputs)
	if (locale === "da") return da_city(inputs)
	if (locale === "de") return de_city(inputs)
	if (locale === "en") return en_city(inputs)
	if (locale === "es") return es_city(inputs)
	if (locale === "fr") return fr_city(inputs)
	if (locale === "hu") return hu_city(inputs)
	if (locale === "it") return it_city(inputs)
	if (locale === "nl") return nl_city(inputs)
	if (locale === "pl") return pl_city(inputs)
	if (locale === "pt") return pt_city(inputs)
	return sv_city(inputs)
};